<template>
  <h3
    class="text-color-topaz-light font-museo-500 related-title xs:pl-0 pl-[0.813rem]"
  >
    {{ $t("profiles.titles.relatedVenues") }}
  </h3>
  <carousel
    :breakpoints="breakpointSwitch()"
    :transition="500"
    :wrap-around="false"
    class="carousel fixed-carousel-arrows"
    :aria-label="$t('profiles.titles.relatedVenues')"
    @mousedown="handleMouseDown"
    @mousemove="cancelOpen"
    @mouseup="handleMouseUp"
  >
    <slide
      v-for="(venue, index) in venuesRelated"
      :key="venue.id"
      :aria-hidden="false"
    >
      <venue-card
        v-if="venue"
        :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
        :venue="venue"
        type="small"
        :is-link="showLink"
      />
    </slide>
  </carousel>
</template>

<script setup>
import { BREAKPOINTS } from "@/constants.js";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import VenueCard from "@/components/wegow/ui/cards/VenueCard.vue";
import { ref } from "vue";

const props = defineProps({
  venuesRelated: {
    type: Array,
    default: undefined
  },
  breakpoints: {
    type: String,
    default: "short"
  }
});
const showLink = ref(true);
const isClicking = ref(true);
const handleMouseDown = () => {
  isClicking.value = true;
};
const cancelOpen = () => {
  if (isClicking.value && showLink.value) {
    showLink.value = false;
  }
};
const handleMouseUp = () => {
  if (isClicking.value) {
    setTimeout(() => {
      isClicking.value = false;
      showLink.value = true;
    }, 250);
  }
};
const breakpointSwitch = () => {
  switch (props.breakpoints) {
    case "large":
      return BREAKPOINTS.largeSectionProfileRelated;
    case "short":
      return BREAKPOINTS.eventProfileRelated;
    case "small":
      return BREAKPOINTS.smallEventCard;
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
</style>
